import React, {Component} from 'react';

let HttpService = require('../Managers/HttpService');
let envConfig;
let Quote =  require('../Managers/Quote');

export default class ApplicationSubmitted extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showRedirect: true
        };
    }

    componentWillMount() {
        envConfig = HttpService.getConfigForHost();
    }

    componentDidMount() {
        $('html, body').animate({
            scrollTop: $('body').offset().top - $('header.site-header').height()
        }, 500);

        // grab the variables, build the URL,
        // set up the spinner, count down, etc.
        let asn = window.localStorage.getItem('ASN');
        let refno = Quote.getByPath('BaseIndividualApplication', 'referenceNumber');
        let dob = Quote.getByPath('BaseIndividualApplication', 'birthDate');

        this.setupParams(asn, refno, dob);

        if (window.uorn(asn) || window.uorn(refno) || window.uorn(dob)) {
           this.hideRedirect();
        } else {
            let url = envConfig.tatLandingAfterSubmittedReference.url;
            url = url.replace('{asn}', asn);
            url = url.replace('{refno}', refno);
            url = url.replace('{dob}', dob);

            setTimeout(() => {
                window.location.assign(url);
            }, 3000);
        }
    }

    setupParams(asn, refno, dob) {
        this.setState({
            asn,
            refno,
            dob
        });
    }

    hideRedirect() {
        this.setState({
            showRedirect: false
        });
    }

    render() {
        return(
            <div>
                <question-row class="header-row">
                    <h1>Application Successfully Submitted</h1>
                    <p>Thank you. Your application has been received by our referencing team.</p>
                    {this.state.showRedirect ?
                        <div>
                            <p>You are now being redirected to our Tenant Application Tracker</p>
                            <div className="loading">
                                <div className="spinner">
                                    <p><strong>Redirecting...</strong></p>
                                    <div className="bounce1" />
                                    <div className="bounce2" />
                                    <div className="bounce3" />
                                </div>
                            </div>
                        </div>
                    :
                        <p>Something has gone wrong. Please contact our support team with reference number {this.state.refno}</p>
                    }
                </question-row>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Screens/ApplicationSubmitted.js